import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DEFAULT_TITLE_FONT_SIZE, FEATURE_NAME, IState } from '../Init.model'

const initialState: IState = {
  title: null,
  titleFontSize: DEFAULT_TITLE_FONT_SIZE,
  seeAllScoresButton: true,
  hideEmptyResults: false,
  backgroundImage: null,
}

export const initSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setWidgetTitle(state, action: PayloadAction<string | null>) {
      state.title = action.payload
    },
    setWidgetTitleFontSize(state, action: PayloadAction<number>) {
      state.titleFontSize = action.payload
    },
    setSeeAllScoresButton(state, action: PayloadAction<boolean>) {
      state.seeAllScoresButton = action.payload
    },
    setHideEmptyResults(state, action: PayloadAction<boolean>) {
      state.hideEmptyResults = action.payload
    },
    setBackgroundImage(state, action: PayloadAction<string | null>) {
      state.backgroundImage = action.payload
    },
  },
})

export const {
  setWidgetTitle,
  setWidgetTitleFontSize,
  setSeeAllScoresButton,
  setBackgroundImage,
  setHideEmptyResults,
} = initSlice.actions
